// test2206
(2206 && 0);
